Vue.component('ack-login', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-login',
    mixins: [languageMixins],
    created() {
      
    },
    mounted() {
      appLog.log('ack-login mounted')
      if (window.location.hash === '#recover') {
        this.showLoginForm = false;
      }
    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }
      
    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']), 
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
    },
    data() {
      return {
        pageId: 'login-page',
        showLoginForm: true
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading']),
      //...Vuex.mapActions('sliders', ['getSlideList'])
      toggleForms() {
        this.showLoginForm = !this.showLoginForm;
      }
    },
    beforeDestroy() {
      
    },
    watch: {
      
      data1: {
        handler() {
          
          
          
        },
        deep: false
      }
    }
  })